import React from 'react';

const Button = ({ type, text, loading, onClick }) => (
  <button
    type={type}
    onClick={onClick}
    className="group relative flex justify-center p-2 sm:px-8 sm:py-3 text-xs sm:text-sm font-semibold rounded border border-green-800 text-white bg-green-200 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700 transition duration-200 ease-in-out"
  >
    {loading ? (
      <span className="flex items-center">
        <span className="ml-2">Loading...</span>
      </span>
    ) : (
      <span>{text}</span>
    )}
  </button>
);

export default Button;
